// extracted by mini-css-extract-plugin
export default {"drawerTitle":"drawerTitle--aPK4W","V2Confirm":"V2Confirm--WMNyf","V2ConfirmNoFooter":"V2ConfirmNoFooter--DaARL","markerAnimationScale":"markerAnimationScale--XBlsf"};